import ContactView from "layouts/contact-view";
import { getClientAccessToken, getClientSession } from "utils/clientSession";
import { Navigate } from "react-router-dom";

export default function ClientContactView() {
  const session = getClientSession();
  const accessToken = getClientAccessToken();

  if (!session || !accessToken) {
    return <Navigate to="/login" replace />;
  }

  return (
    <ContactView
      portalVariant="client"
      expectedCustomerId={session.customerId}
      clientAccessToken={accessToken}
    />
  );
}
